// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url: "https://localhost:4200",
  autoSAMLProvider: "azure",
  SAML_url : "https://assist-sandbox.astrazeneca.com/api", //"https://search.astrazeneca.com/api"
  assistant_url: "https://neural-sandbox2.astrazeneca.com", //"https://neural.astrazeneca.com"
  api_url: "https://insightsvault-dev.astrazeneca.com",
  // api_url: "http://localhost:4200",
  production: false
};

// "buildOptimizer": false,
// "optimization": false,
// "vendorChunk": true,
// "extractLicenses": false,
// "sourceMap": true,
// "namedChunks": true
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
